'use client';

import { useEffect, useState } from 'react';

const COOKIE_NAME = 'cm_banner_dismissed';
const COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

function hasDismissedCookie(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE_NAME}=1`));
}

export function useSmartBannerDismiss(): { dismissed: boolean; dismiss: () => void } {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(hasDismissedCookie());
  }, []);

  const dismiss = (): void => {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    // biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API not yet supported across all target browsers
    document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
    setDismissed(true);
  };

  return { dismissed, dismiss };
}
